(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react-emotion'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react-emotion'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.reactEmotion);
    global.NotificationContainerCss = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _reactEmotion) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.notificationContainerClass = undefined;

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow: hidden;\n  position: absolute;\n  z-index: 5000;\n  left: 50%;\n  transform: translateX(-50%);\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow: hidden;\n  position: absolute;\n  z-index: 5000;\n  left: 50%;\n  transform: translateX(-50%);\n']);

  // Notification Container styles
  var notificationContainerClass = exports.notificationContainerClass = (0, _reactEmotion.css)(_templateObject);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Notifications/NotificationContainer.css.js
// module id = 1149
// module chunks = 0